import React, { useEffect } from "react";
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
function Admission() {
    const location = useLocation();
       // Scroll to the section if specified in the URL state
        useEffect(() => {
          if (location.state?.scrollTo) {
            const element = document.getElementById(location.state.scrollTo);
            if (element) {
              // Use smooth scrolling to the section
              element.scrollIntoView({ behavior: "smooth" });
            }
          }
        }, [location.state]);

    const tabs = [
        { title: 'IBPYP', content: () => <div id='OnlineRegistration' >
        
        <div  className='cam-lower-sec'>
           
        <h1   className='title'>PYP Admission</h1>
        </div>
   
       <div  className='admission-details'>

       
        <h3>Students Enrolling into the PYP</h3>
        <p>There is a structured process that parents must follow to enroll their child in the IBPYP program. Various factors contribute to the selection of a candidate for the school, with the Principal and the Administrator playing a crucial role in the decision-making process. The factors taken into consideration are:</p>
        <p><b>Admission in Pre-Primary</b> are on the basis of 'First Come First Serve' basis.</p>
        <p><b>Admission from class I to V</b></p>
        <ul>
            <li>Progress Report of previous class</li>
            <li>The potential of the applicant to benefit from the programme(s) and educational services available</li>
            {/* <li>Proficiency in English</li> */}
            <li>Categories for admission at the entry level are specified as follows:</li>
        </ul>
        
        <div className='admission-categoris'>
            <div className='categoris-list'><span>RTE</span>  <p>-</p> </div>
            
            <div className='categoris-persent'>25% </div>

        </div>
        <div className='admission-categoris'>
            <div className='categoris-list'><span>Siblings of students studying in the school</span>  <p>-</p> </div>
            
            <div className='categoris-persent'>5% </div>

        </div>
        <div className='admission-categoris'>
            <div className='categoris-list'><span>Teacher’s Wards</span>  <p>-</p> </div>
            
            <div className='categoris-persent'>5% </div>

        </div>
        <div className='admission-categoris'>
            <div className='categoris-list'><span>Transferable cases</span>  <p>-</p> </div>
            
            <div className='categoris-persent'>5% </div>

        </div>
        <div className='admission-categoris'>
            <div className='categoris-list'><span>Defence / Police wards</span>  <p>-</p> </div>
            
            <div className='categoris-persent'>10% </div>

        </div>
        <div className='admission-categoris'>
            <div className='categoris-list'><span>General</span>  <p>-</p> </div>
            
            <div className='categoris-persent'>50% </div>

        </div>
         <br></br>   
        <h3>Admission Form Requirements</h3>
        <p><b>Age Criteria for Admissions</b></p>
        <ul>
          <li><b>Nursery -</b> The child must be 3 years of age as on 31st March of the academic year.</li>
          <li><b>Grade 1 - </b> The child must be 6 years of age as on 31st March of the academic year.</li>
        </ul>
        <p><b>For students enrolling in Pre-Primay</b></p>
        <ul>
        <li>Birth Certificate. </li>
        <li>4 passport size photographs.</li>
        <li>Aadhar Card.</li>
        </ul>
        <p><b>For students enrolling in classes I to V</b></p>
        <ul>
            <li>PEN (Permanent Education Number) from previous school.</li>
            <li>Birth Certificate</li>
            <li>Original Transfer Certificate from the school last attended.</li>
            <li>4 passport size photographs.</li>
            <li>Aadhar Card.</li>
            <li>Report Card from previous successfully completed class</li>
            <li>Photocopy of the scholastic achievements record from the school last attended</li>
            <li>Any other information parents consider necessary for the school to know</li>
        </ul>
        <p><b>NOTE:</b></p>
        <ul>
            <li>Admission is on the basis of 'First Come First Serve' for Pre-Primary.</li>
            <li>Admission in other classes is against vacancies only.</li>
            <li>If the number of applicants is more than the number of seats, Lottery System will be followed.</li>
        </ul>
        <p>Sanskar School is an authorized PYP school.

Only schools authorised by the IB Organization can offer any of its four academic programmes: the Primary Years Programme (PYP), the Middle Years Programme (MYP), the Diploma Programme (DP), or the Career-related Programme (CP). For further information about the IB and its programmes, visit <Link to="https://www.ibo.org/"> http://www.ibo.org</Link> </p>
</div>



    
   
        </div> },
        { title: 'IGCSE', content: () => <div>
          
          <div className='cam-lower-sec'>
        <h1 className='title'>Cambridge International Education Admission</h1>
        </div>
         <div className='admission-details'>
      
   
      
        <ul>
            <li>PEN (Permanent Education Number) from previous school.</li>
            <li>Birth Certificate</li>
            <li>Original Transfer Certificate from the school last attended.</li>
            <li>4 passport size photographs.</li>
            <li>Aadhar Card.</li>
            <li>Report Card from previous successfully completed class</li>
            <li>Photocopy of the scholastic achievements record from the school last attended</li>
            <li>Any other information parents consider necessary for the school to know</li>
        </ul>
     
        </div>
        <div className='admission-details'>
        <h3>Admission Form Requirements</h3>
        <p><b>For students enrolling in Cambridge International Education</b></p>
   
      
        <ul>
            <li>PEN (Permanent Education Number) from previous school.</li>
            <li>Birth Certificate</li>
            <li>Original Transfer Certificate from the school last attended.</li>
            <li>4 passport size photographs.</li>
            <li>Aadhar Card.</li>
            <li>Report Card from previous successfully completed class</li>
            <li>Photocopy of the scholastic achievements record from the school last attended</li>
            <li>Any other information parents consider necessary for the school to know</li>
        </ul>
     
        </div>
        </div> },
        { title: 'IBDP', content: () => <div>
    
    <div className='cam-lower-sec'>
        <h1 className='title'>IBDP Admission</h1>
        </div>
        <div className='admission-details'>
        <h3>Students Enrolling into the IBDP</h3>
 
   
        <ul>
            <li>To enrol into the Diploma Programme, a student should have completed Grade X successfully with a pass percentage of at least 60% from the IGCSE, CBSE, ICSE or other authorized   Board</li>
            <li>Transfer candidates from other schools are eligible to enrol to Grade XI</li>
            <li>New candidates will take a placement test for English, Mathematics and second language, just to ensure that they have adequate knowledge, understanding and skills to cope with the demands of the DP as well as to assess which HL/SL Courses they are to opt for</li>
            <li>The parents of new applicants will be given detailed orientation about the philosophy, benefits and demands of IBDP in the school itself, to help them make an informed decision</li>
            <li>The school will discuss the financial implications of the IBDP with you to ensure that you are able to support your ward throughout the IBDP at Sanskar School as no scholarships are available</li>
            <li>The applicant is subjected to Career Counselling if doubtful about his/her subject choice</li>
        </ul>

        <h3>Admission Form Requirements</h3>
 
   
 <ul>
 <li>PEN (Permanent Education Number) from previous school.</li>
            <li>Birth Certificate</li>
            <li>Original Transfer Certificate from the school last attended.</li>
            <li>4 passport size photographs.</li>
            <li>Aadhar Card.</li>

     <li>Mark Sheet of Grade X</li>
     <li>Photocopy of the Scholastic and Co-Scholastic achievements record from the school last attended</li>
     <li>Any other information parents consider necessary for the school to know</li>
 </ul>
 <p><b>NOTE:</b></p>
        <ul>
            <li>Admission in class XI is against vacancies and the combination of subjects only.</li>
        
        </ul>
        <p>Sanskar School is an authorized school for the Diploma Programme. All IB schools share a common philosophy–a commitment to high-quality, challenging, international education that Sanskar School believes is which Sanskar School believes is important for our students. Only schools authorised by the IB Organization can offer any of its three academic programmes: the Primary Years Programme (PYP), the Middle Years Programme (MYP), the Diploma Programme (DP), or the Career-related Programme (CP). For further information about the IB and its programmes, please visit: </p> <p><Link to="https://www.ibo.org/">http://www.ibo.org</Link> </p>
    </div>
        </div> },
      
      { title: 'Online Registration', content: () => 
      <div>
    
    <div  className='cam-lower-sec'>
        <h1 className='title'>Online Registration</h1>
        </div>
        <div className='admission-details'>
    
      <div className='online-registration-row'>
        <div className='online-registration-box'>
            <h3 className='registration-heading'>Online Registration</h3>
            <h3 className='registration-heading'>2026-27</h3>
            <Link to="https://erp.sanskarjaipur.com/Reg/Terms?ins=OTA1YWVlOTktMjM3ZS00MjI2LThmMjAtZjMxNmVjMGRmZGRjNzg3OA==&br=MjRkZTdhYjgtZTI5OC00MTNiLTg0YzAtNzdiMjUzMzYwNzQ2Nzg3OA==&session=2026"> Register Now

                </Link> 
        </div>
        {/* <div className='online-registration-box'>
            <h3 className='registration-heading'>Online Registration</h3>
            <p>for Classes VI to IX (Cambridge) and IBDP (XI)</p>
            <Link to="https://erp.sanskarjaipur.com/Reg/Terms?ins=OTA1YWVlOTktMjM3ZS00MjI2LThmMjAtZjMxNmVjMGRmZGRjNzg3OA==&br=MjRkZTdhYjgtZTI5OC00MTNiLTg0YzAtNzdiMjUzMzYwNzQ2Nzg3OA==&session=2025"> Register Now</Link> 
        </div> */}


      </div>
      </div>
    
        </div> },
    
      ];
  return (
    <div>
            <div  className='ibdp-hero-sec'>
        <img  src='newimg/Screenshot_24.webp' alt="Hero" />

      </div>
      <div  className='online-registration-sec'>

      <HorizontalTabs tabs={tabs} />
      </div>

    </div>
  );
}

export default  Admission;
